import { AudioManager } from '../../core/AudioManager';
import { Vehicle } from '../Vehicle';

export class CarImpactAudio {
    static readonly PRELOAD = ['../assets/sounds/impact_car.wav'] as const;
    private static readonly SRC = CarImpactAudio.PRELOAD[0];
    private static readonly REF_DISTANCE = 5;
    private static readonly DEBOUNCE_MS = 2500;

    private lastPlayTime = -Infinity;

    constructor(
        private readonly audioManager: AudioManager,
        private readonly vehicle: Vehicle,
    ) {}

    public play(): void {
        const now = Date.now();
        if (now - this.lastPlayTime < CarImpactAudio.DEBOUNCE_MS) { return; }
        this.lastPlayTime = now;

        const playbackRate = 0.85 + Math.random() * 0.3;
        this.audioManager.playPositional(CarImpactAudio.SRC, this.vehicle, {
            volume: 1,
            loop: false,
            refDistance: CarImpactAudio.REF_DISTANCE,
            playbackRate,
        });
    }
}
